import React, { useState } from 'react';
import './SavedFiltersDrawer.css';

const SavedFiltersDrawer = ({ 
  isOpen, 
  onClose, 
  savedFilters, 
  filterName,
  onFilterNameChange,
  onSaveFilter,
  onLoadFilter,
  onDeleteFilter,
  currentSport
}) => {
  const [deleteConfirmId, setDeleteConfirmId] = useState(null);

  const handleDeleteClick = (filterId) => {
    if (deleteConfirmId === filterId) {
      onDeleteFilter(filterId);
      setDeleteConfirmId(null);
    } else {
      setDeleteConfirmId(filterId);
    }
  };

  const handleSaveClick = () => {
    if (filterName.trim()) {
      onSaveFilter();
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSaveClick();
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="saved-filters-drawer-overlay" onClick={onClose}></div>
      <div className="saved-filters-drawer">
        <div className="drawer-drag-handle"></div>
        <div className="saved-filters-drawer-header">
          <h3>Saved Filters</h3>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        
        <div className="saved-filters-drawer-content">
          <div className="save-filter-section">
            <div className="save-filter-input-group">
              <input
                type="text"
                placeholder="Filter name..."
                value={filterName}
                onChange={(e) => onFilterNameChange(e.target.value)}
                onKeyPress={handleKeyPress}
                className="filter-name-input"
              />
              <button 
                onClick={handleSaveClick}
                disabled={!filterName.trim()}
                className="save-filter-button"
              >
                Save Current
              </button>
            </div>
          </div>

          <div className="saved-filters-list">
            <h4>Your Filters</h4>
            {savedFilters.length === 0 ? (
              <p className="no-filters-message">No saved filters yet</p>
            ) : (
              <div className="filter-items">
                {savedFilters.map((filter) => (
                  <div key={filter.id} className="filter-item">
                    <div className="filter-item-info">
                      <span className="filter-item-name">{filter.name}</span>
                      <small>{filter.criteria?.version === 2
                        ? `${filter.criteria.category} · ${filter.criteria.gradingFeeMode}`
                        : 'Current view · legacy filter'}</small>
                      <span className="filter-item-date">
                        {new Date(filter.created_at).toLocaleDateString()}
                      </span>
                    </div>
                    <div className="filter-item-actions">
                      <button
                        onClick={() => onLoadFilter(filter)}
                        className="load-filter-button"
                      >
                        Apply
                      </button>
                      <button
                        onClick={() => handleDeleteClick(filter.id)}
                        className={`delete-filter-button ${deleteConfirmId === filter.id ? 'confirm' : ''}`}
                      >
                        {deleteConfirmId === filter.id ? 'Confirm?' : '🗑'}
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default SavedFiltersDrawer;

